import { useState, useEffect } from 'react'
import { filterOutMasterUsers } from '@/shared/lib/userFilters'
import { config } from '@/config/env'

export interface User {
  id: string
  firstName: string
  lastName: string
  email: string
  isActive: boolean
}

export const useUsersList = () => {
  const [users, setUsers] = useState<User[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        setLoading(true)
        const token = localStorage.getItem('access_token')
        const response = await fetch(`${config.apiBaseUrl}/users`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        })

        if (!response.ok) {
          throw new Error('Error al cargar usuarios')
        }

        const data = await response.json()
        // Filtrar solo usuarios activos
        setUsers(filterOutMasterUsers(data.filter((u: User) => u.isActive)))
        setError(null)
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Error desconocido')
        setUsers([])
      } finally {
        setLoading(false)
      }
    }

    fetchUsers()
  }, [])

  return { users, loading, error }
}
